/**
 * CartCouponForm Component for Nova
 * @see mobile: module-theme-hermes/src/modules/sales-rule/components/cart-coupon-form/cart-coupon-form.tsx
 *
 * Mobile: CartCouponForm wraps BaseCartCouponForm from module-flash-sale with isCheckoutScreen={true}
 * Website: NovaCartCouponForm wraps CartCouponForm from module-flash-sale (equivalent component)
 */

'use client';

import React from 'react';
import { CartCouponForm as BaseCartCouponForm } from '@kidslabs/module-flash-sale';
import styles from './cart-coupon-form.module.css';
import { useShippingDiscount } from '../../hooks/use-shipping-discount';

/**
 * NovaCartCouponForm - Nova theme wrapper for module-flash-sale's CartCouponForm
 * @see mobile: module-theme-hermes/src/modules/sales-rule/components/cart-coupon-form/cart-coupon-form.tsx
 *
 * Export as CartCouponForm to match mobile's naming convention
 */
export const CartCouponFormDesktop = () => {
    const shippingDiscountLabel = useShippingDiscount();

    // Mobile passes isCheckoutScreen={true} to BaseCartCouponForm
    return (
        <BaseCartCouponForm
            isCheckoutScreen={true}
            containerClassName={styles.desktopContainer}
            shippingDiscountLabel={shippingDiscountLabel}
        />
    );
};
